import * as React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppSelector } from "app.hook";
import { selectToast } from "states/global-value/global-value.slice";
import { useCallback, useEffect } from "react";
import { ToastType } from "states/global-value/global-value.models";
export interface IToastifyComponentProps {}
export function ToastifyComponent(props: IToastifyComponentProps) {
  const toastRedux = useAppSelector(selectToast);
  const _handleNotification = useCallback(
    (type: ToastType) => {
      switch (type) {
        case ToastType.success:
          toast.success(toastRedux?.message);
          break;
        case ToastType.dark:
          toast.dark(toastRedux?.message);
          break;
        case ToastType.error:
          toast.error(toastRedux?.message);
          break;
        case ToastType.warn:
          toast.warn(toastRedux?.message);
          break;
        case ToastType.info:
          toast.info(toastRedux?.message);
          break;
        default:
          toast(toastRedux?.message);
          break;
      }
      return 1;
    },
    [toastRedux]
  );
  useEffect(() => {
    _handleNotification(toastRedux?.type);
  }, [toastRedux, _handleNotification]);
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={toastRedux?.duration ?? 1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
